import { Button, ButtonWithoutIcon } from '@msaf/core-react'

export type WellButtonLabels =
  | 'Save'
  | 'Save and continue'
  | 'Save and return'
  | 'Save and add another'
  | 'Save and close'
  | 'Cancel'
  | 'Return to view'
  | 'Continue'
  | 'Create well'
  | 'Submit for approval'
  | 'Publish'
  | 'Submit'
  | 'Publish well'

export interface ActionProps extends ButtonWithoutIcon {
  label: WellButtonLabels
}
interface WellEditButtonsProps {
  actions: Array<ActionProps>
  isLoading?: boolean
}

export default function WellEditButtons({ actions, isLoading = false }: WellEditButtonsProps) {
  return (
    <>
      {/** `index` is fine as a key here as the list of buttons are unlikely to change once rendered */}
      {actions.map((action: ButtonWithoutIcon, index) => (
        <Button key={index} isSkeleton={isLoading} {...action} />
      ))}
    </>
  )
}
